import useModalDispatch from "../../hooks/useModalDispatch";
import CompensationRequestModal from "../../modals/CompensationRequestModal";
import Button from "../theme/Button";

const NewCompensationButton = ({
  eventId,
  future,
  refreshList,
}: {
  future: boolean;
  eventId: string;
  refreshList: () => void;
}) => {
  const dispatchModal = useModalDispatch(CompensationRequestModal);

  return (
    <>
      <Button
        className="new-compensation-button"
        disabled={!future}
        variant="contained"
        onClick={() =>
          dispatchModal({
            eventId,
            onSuccess: refreshList,
          })
        }
      >
        Vergoeding aanvragen
      </Button>
    </>
  );
};

export default NewCompensationButton;
